export default "__VITE_ASSET__DGTWXr9h__"